import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import {CUtilit, ArmaDate, ModalUtilit, getJsonLocalStorage} from '../../classes/utilit';
import { DataService } from '../../data.service';
import { AppToolbarService } from '../../components/toolbar/services/app-toolbar.service';
import { CST_WEB_INPUT_DISPOSITION, CST_TOOLBAR_BTN_EVENT } from '../../components/toolbar/app-tool-bar/app-tool-bar.component';
import {ArmaRestOrderList, ArmaRestResultSteelListSend} from 'src/app/classes/json-interface';
import { SteelListStatus } from 'src/app/classes/const';
import { MatDialog } from '@angular/material/dialog';
import { DialogImportComponent } from 'src/app/components/dialog/dialogImport/dialogImport.component';
import { LoggedUserService } from 'src/app/services/loged-user/loged-user.service';
import { g_params } from 'src/app/classes/global-param';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {UtilitAnalysis} from '../../classes/decorticage/Utilits-analysis';
import {TableFilter} from '../../components/arma-filter-item/ColumnFilter';
import {DialogOrderNoteComponent} from '../../components/dialog/dialog-order-note/dialog-order-note.component';

const CST_STORAGE_VISIBILITY_COLUMN_COMMADES_PAGE = 'CST_STORAGE_VISIBILITY_COLUMN_COMMADES_PAGE';

const CST_STORAGE_VISIBILITY_COLUMN_COMMADES_PAGE_DEFAULT: ParamVisiblilityColumn = {
  showCancel: false,
  showValidated: true,
  showWaiting: true,
  allowAllSite: false
};

interface ParamVisiblilityColumn {
  showCancel?: boolean;
  showValidated?: boolean;
  showWaiting?: boolean;
  allowAllSite?: boolean;
}

const CST_MAT_TABLE_COLUMN_CODE = 'Code';
const CST_MAT_TABLE_COLUMN_ORDER = 'Order';
const CST_MAT_TABLE_COLUMN_CUSTOMER_REFERENCE = 'CST_MAT_TABLE_COLUMN_CUSTOMER_REFERENCE';
const CST_MAT_TABLE_COLUMN_DESIGNATION = 'designation';
const CST_MAT_TABLE_COLUMN_DRAWING = 'drawing';
const CST_MAT_TABLE_COLUMN_SITECODE = 'siteCode';
const CST_MAT_TABLE_COLUMN_STATUS = 'status';
const CST_MAT_TABLE_COLUMN_CREATION_DATE = 'creation_date';
const CST_MAT_TABLE_COLUMN_DELIVERY_DATE = 'delivery_date';
const CST_MAT_TABLE_COLUMN_ACTION = 'action';
const CST_MAT_TABLE_COLUMN_MORE = 'more';

@Component({
  selector: 'app-commandes',
  templateUrl: './commandes.component.html',
  styleUrls: ['./commandes.component.css']
})
export class CommandesComponent implements OnInit {

  public lockElement: boolean = false;

  public readonly CST_MAT_TABLE_COLUMN_CODE = CST_MAT_TABLE_COLUMN_CODE;
  public readonly CST_MAT_TABLE_COLUMN_ORDER = CST_MAT_TABLE_COLUMN_ORDER;
  public readonly CST_MAT_TABLE_COLUMN_CUSTOMER_REFERENCE = CST_MAT_TABLE_COLUMN_CUSTOMER_REFERENCE;
  public readonly CST_MAT_TABLE_COLUMN_DESIGNATION = CST_MAT_TABLE_COLUMN_DESIGNATION;
  public readonly CST_MAT_TABLE_COLUMN_DRAWING = CST_MAT_TABLE_COLUMN_DRAWING;
  public readonly CST_MAT_TABLE_COLUMN_SITECODE = CST_MAT_TABLE_COLUMN_SITECODE;
  public readonly CST_MAT_TABLE_COLUMN_STATUS = CST_MAT_TABLE_COLUMN_STATUS;
  public readonly CST_MAT_TABLE_COLUMN_CREATION_DATE = CST_MAT_TABLE_COLUMN_CREATION_DATE;
  public readonly CST_MAT_TABLE_COLUMN_DELIVERY_DATE = CST_MAT_TABLE_COLUMN_DELIVERY_DATE;
  public readonly CST_MAT_TABLE_COLUMN_ACTION = CST_MAT_TABLE_COLUMN_ACTION;
  public readonly CST_MAT_TABLE_COLUMN_MORE = CST_MAT_TABLE_COLUMN_MORE;

  public HTML_TABLE_HEADER_COL: string[] = [
    this.CST_MAT_TABLE_COLUMN_CODE,
    this.CST_MAT_TABLE_COLUMN_ORDER,
    CST_MAT_TABLE_COLUMN_CUSTOMER_REFERENCE,
    this.CST_MAT_TABLE_COLUMN_DESIGNATION,
    this.CST_MAT_TABLE_COLUMN_DRAWING,
    this.CST_MAT_TABLE_COLUMN_SITECODE,
    this.CST_MAT_TABLE_COLUMN_STATUS,
    this.CST_MAT_TABLE_COLUMN_CREATION_DATE,
    this.CST_MAT_TABLE_COLUMN_DELIVERY_DATE,
    this.CST_MAT_TABLE_COLUMN_ACTION,
    this.CST_MAT_TABLE_COLUMN_MORE
  ];
  public HTML_TABLE_DATASOURCE: MatTableDataSource<ArmaRestOrderList> = new MatTableDataSource<ArmaRestOrderList>([]);

  public HTML_INPUT_FILTER: string = '';

  public readonly HTML_ShowAllSiteVisibility: boolean = g_params.g_arraySite.length > 1;
  public readonly useJoiningCode: boolean = g_params.useJoiningCode;

  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  readonly visibilityData: ParamVisiblilityColumn = getJsonLocalStorage(CST_STORAGE_VISIBILITY_COLUMN_COMMADES_PAGE, CST_STORAGE_VISIBILITY_COLUMN_COMMADES_PAGE_DEFAULT);

  constructor(private router: Router,
              private mDataService: DataService,
              private mToolbarService: AppToolbarService,
              private mMatDialog: MatDialog,
              private mLoggedUser: LoggedUserService,
              private mArmaServMethods: ArmaServServerMethods,
              private mTranslateService: TranslateService,
              private mSnackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.mToolbarService.toolbarPageTitle = 'Saisie en ligne';
    this.mToolbarService.getObservableSiteChange().subscribe(newSite => this.refreshListOrder());
    if (!this.mLoggedUser.rightShowWebInput) {
      this.router.navigateByUrl('').catch(console.error);
      return;
    }
    this.mToolbarService.setDisposition(CST_WEB_INPUT_DISPOSITION);
    this.mToolbarService.getObservableClick(true).subscribe(next => this.onToolbarItemClick(next));
    this.HTML_TABLE_DATASOURCE.sort = this.sort;
    this.HTML_TABLE_DATASOURCE.filterPredicate = (data: ArmaRestOrderList, filter: string) => filterValue(data, this.visibilityData, this.HTML_INPUT_FILTER);
    this.refreshListOrder().catch(console.error);
  }

  onToolbarItemClick(eventName: string) {
    switch (eventName) {
      case CST_TOOLBAR_BTN_EVENT.Refresh:
        this.refreshListOrder();
        break;
    }
  }

  async cancelCommande(element: ArmaRestOrderList) {
    const result: boolean = await ModalUtilit.yesNo(this.mMatDialog, 'Annuler la commande ?', 'Confirmation');
    if (result) {
      await this.mArmaServMethods.cancelSteelList(element.Code).catch(console.error);
      this.refreshListOrder(false).catch(console.error);
    }
  }

  public editCommande(element: ArmaRestOrderList) {
    if (this.lockElement)
      return;

    this.lockElement = true;
    try {
      // On affecte un code chantier au décorticage que l'on veux afficher, c'était pas affacter à la création du déco avant
      if (!element.CodeSite && g_params.g_arraySite.length > 0)
      element.CodeSite = g_params.g_arraySite[0].CODECHANTIER;
      // Lancer la page décorticage avec le codedecorticage correspondant
      // decorticage/:codedec
      this.mDataService.setInfoSteelList(element);
      this.mToolbarService.setSelectedSiteCode(element.CodeSite);
      this.router.navigateByUrl('decorticage/' + element.Code).catch(console.error);
    } finally {
      this.lockElement = false;
    }
  }

  /**
   * Navige sur la page decorticage sans passer d'id de liste d'acier
   */
  async createNewOrder() {
    // On navige sur la page des decorticag avec l'id zero
    this.mDataService.setInfoSteelList(undefined);
    this.router.navigateByUrl('decorticage/0');
  }

  async duplicateOrder(element: ArmaRestOrderList) {
    if (!element) {
      console.error('element undefined');
      return;
    }
    let newOrderList: ArmaRestOrderList | undefined = undefined;
    this.lockElement = true;
    try {
      newOrderList = await this.mArmaServMethods.duplicateSteelList(element.Code);
    } finally {
      this.lockElement = false;
    }
    if (newOrderList)
      this.editCommande(newOrderList);
  }

  onSeeNoteClick(element: ArmaRestOrderList) {
    DialogOrderNoteComponent.displayDialog(this.mMatDialog, element.Note, true);
  }

  importOnCommand(element: ArmaRestOrderList) {
    if (!element) {
      console.error('element undefined');
      return;
    }
    this.mMatDialog.open(DialogImportComponent,
      {
        width: '350px',
        disableClose: true,
        data: element
      }
    );
  }

  async sendOrder(element: ArmaRestOrderList) {
    if (!await UtilitAnalysis.modalConfirmSendOrder(this.mMatDialog))
      return;
    let isSend: ArmaRestResultSteelListSend;
    this.lockElement = true;
    try {
      isSend = await this.mArmaServMethods.setSteelListAsSend(element.Code);
    } finally {
      this.lockElement = false;
    }
    if (isSend.IsSend)
      await this.refreshListOrder();
    else
      await UtilitAnalysis.checkResultSteelListSend(isSend, this.mSnackBar, this.mTranslateService, true,
        () => this.editCommande(element));
  }

  public onCheckShowAllSiteChange() {
    this.saveVisibilityColumn();
    this.refreshListOrder(false).catch(console.error);
  }

  private async refreshListOrder(clear: boolean = true) {
    if (clear)
      this.HTML_TABLE_DATASOURCE.data = [];
    this.lockElement = true;
    try {
      const selectedSite = CUtilit.getSelectedSiteCode();
      const allowAllSite = this.visibilityData.allowAllSite;
      this.HTML_TABLE_DATASOURCE.data = await this.mArmaServMethods.loadListSteelList(allowAllSite ? '' : selectedSite);
      this.onFilterChange();
    } catch (error) {
      console.error(error);
    } finally {
      this.lockElement = false;
    }
  }

  /**
   * Code pour convertir la date number passé depuis le datasnap en une date delphi utilisable
   * @param dateDelphi ?
   */
  HTML_CONVEERT_DELPHI_DATE(dateDelphi: any): string {
    return ArmaDate.createFromUnixTime(dateDelphi).toDate();
  }

  updateVisivilityColumn(save: boolean) {
    this.onFilterChange();
    if (save)
      this.saveVisibilityColumn();
  }

  private saveVisibilityColumn() {
    localStorage.setItem(CST_STORAGE_VISIBILITY_COLUMN_COMMADES_PAGE, JSON.stringify(this.visibilityData));
  }

  /**
   * Pour faire l'appel de la fonction filterPredicate du tableau
   * Seulement une modification de filter filter permet l'appel de la fonction
   */
  onFilterChange() {
    this.HTML_TABLE_DATASOURCE.filter = new Date().getTime().toString();
  }

  getCssClassSteelList(row: ArmaRestOrderList): any {
    return {
      'default-st': row.StatusInteger == SteelListStatus.stWaiting,
      'validate-st': row.StatusInteger == SteelListStatus.stValidate,
      'send-st': row.StatusInteger == SteelListStatus.stSend,
      'deny-st': (row.StatusInteger == SteelListStatus.stDeny || row.StatusInteger == SteelListStatus.stCancel)
    };
  }

  /**
   * Traduit dans le HTML
   */
  public HTML_getTxtEditConsult(element: ArmaRestOrderList): string {
    if (element.CanEdit == 1)
      return 'Modifier';
    return 'Consulter';
  }

  public asSteelList(element: ArmaRestOrderList): ArmaRestOrderList {
    return element;
  }
}

const filterValue = (data: ArmaRestOrderList,
                     visibilityData: ParamVisiblilityColumn,
                     filter: string): boolean => {
  // Pour gerer l'affichage de la commande en fonction du statut
  const boolCheckFilterWithStatus: boolean = (
    (!!visibilityData.showValidated && ((+data.StatusInteger == SteelListStatus.stValidate) || (+data.StatusInteger == SteelListStatus.stSend))) ||
    (!!visibilityData.showWaiting && (+data.StatusInteger == SteelListStatus.stWaiting)) ||
    (!!visibilityData.showCancel && ((+data.StatusInteger == SteelListStatus.stDeny) || (+data.StatusInteger == SteelListStatus.stCancel)))
  );
  // Pour gerer l'affichage de la commande en fonction des param de la commande
  const boolCheckFilterWithText = TableFilter.matchJson(data, filter, 2);
  return boolCheckFilterWithStatus && boolCheckFilterWithText;
};
